import katesbreakfast from "../components/images/katesbreakfast.png";
// import facebook from "../components/images/facebook.png";
import todo from "../components/images/todo";

const projects = [
  {
    id: "1",
    title: "Breakfast Ordering App Case Study",
    description:
      " An app  that allows users to easily order and pick up fresh, healthy breakfast from Kate’s Kitchen.",
    image: katesbreakfast,
    code: "https://drive.google.com/file/d/1xgmLKEgNKXxvWkqtdNZBa2mkwqHqh1iA/view?usp=sharing",
    url: "https://www.figma.com/proto/R75ZnNTLvYcEGfLhrfT7Eu/Kates-Kitchen?node-id=160%3A766&scaling=scale-down&page-id=101%3A180&starting-point-node-id=160%3A766",
  },
  // {
  //   id: "2",
  //   title: "Faceclone",
  //   description:
  //     "Facebook clone built with react, material ui and firebase as part of my learning process",
  //   image: facebook,
  //   url: "https://mawusikpodo.github.io/blog/",
  //   code: "https://github.com/mawusikpodo/blog",
  // },
  {
    id: "3",
    title: "Expence tracker app",
    description: "This app was built with react and material ui",
    image: todo,
    url: "https://mawusikpodo-todo.herokuapp.com",
    code: "https://github.com/mawusikpodo/todoapp",
  },
  // {
  //   id: "4",
  //   title: "WeatherApp",
  //   description: "Built with react, material ui and open weather API",
  //   image: facebook,
  //   url: "https://mawusikpodo.github.io/WeatherApp/",
  //   code: "https://github.com/mawusikpodo/WeatherApp",
  // },
];

export default projects;
